/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiSortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}


export function instanceOfApiSortDirection(value: any): boolean {
    for (const key in ApiSortDirection) {
        if (Object.prototype.hasOwnProperty.call(ApiSortDirection, key)) {
            if (ApiSortDirection[key as keyof typeof ApiSortDirection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiSortDirectionFromJSON(json: any): ApiSortDirection {
    return ApiSortDirectionFromJSONTyped(json, false);
}

export function ApiSortDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSortDirection {
    return json as ApiSortDirection;
}

export function ApiSortDirectionToJSON(value?: ApiSortDirection | null): any {
    return value as any;
}

export function ApiSortDirectionToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiSortDirection {
    return value as ApiSortDirection;
}

